import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
declare var $: any;

@Component({
    selector: 'ups-dashboard-accordeon-head',
    template: require('./ups-dashboard-accordeon-head.component.html'),
    encapsulation: ViewEncapsulation.None
})
export class UpsDashboardAccordeonHeadComponent implements OnInit {


    @Input() display: string = '';
    public _display: string = '';
    public ham: boolean = false;
    ngOnInit() {

    }

    showHam() {
        this.ham = (this.ham) ? false : true;
    }

    searchInformation() {
        // Call API for search Information
    }

}


